module.exports = __webpack_public_path__ + "files/94144acf73af90c2f13a92deb3655099.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/food_drink-3.png
// module id = 513
// module chunks = 76